<template>
  <div>
    <div class="form-group">
      <label> {{ __("forms.TrainingRequests.typology") }}</label>
      <select
        name="trainingRequest[typology]"
        class="form-control"
        required
        v-model="typologyData"
      >
        <option>---</option>
        <option :value="type.id" v-for="type in typologies">
          {{ type.value }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <div class="form-group" v-if="typologyData === 'course'">
        <label>{{ __("forms.TrainingRequests.courses") }}</label>
        <select
          name="trainingRequest[training_need_id]"
          class="form-control"
          required
          v-model="trainingNeedId"
          @change="setRequestText($event)"
        >
          <option>---</option>
          <option :value="course.id" v-for="course in courses">
            {{ course.name }}
          </option>
        </select>
      </div>
      <div class="form-group" v-if="typologyData === 'course_to_catalog'">
        <label>{{ __("forms.TrainingRequests.courses") }}</label>
        <select
          name="trainingRequest[training_need_id]"
          class="form-control"
          required
          v-model="trainingNeedId"
          @change="setRequestText($event)"
        >
          <option>---</option>
          <option :value="course.id" v-for="course in catalogs_courses">
            {{ course.name }}
          </option>
        </select>
      </div>
      <label>{{ __("forms.TrainingRequests.applicant") }}</label>
      <div class="form-group">
        <select
          name="trainingRequest[applicant_person_id]"
          class="form-control"
          required
          v-model="applicantPersonId"
        >
          <option>---</option>
          <option :value="person.id" v-for="person in people">
            {{ person.fullName }}
          </option>
        </select>
      </div>
      <label>{{ __("forms.TrainingRequests.asked_for") }}</label>
      <div class="form-group">
        <select
          name="trainingRequest[asked_for_person_id]"
          class="form-control"
          required
          v-model="askedForPersonId"
        >
          <option>---</option>
          <option :value="person.id" v-for="person in people">
            {{ person.fullName }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>{{ __("forms.TrainingRequests.request") }}</label>
        <textarea name="trainingRequest[request]" v-model="requestData">
        </textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.typologyData = this.typology;
    this.applicantPersonId = this.applicant_person_id;
    this.askedForPersonId = this.asked_for_person_id;
    this.trainingNeedId = this.training_need_id;
    this.requestData = this.request;

    var v1 = { id: "free", value: "Libera" };
    var v2 = { id: "course", value: "Corso" };
    var v3 = { id: "course_to_catalog", value: "Corso a catalogo" };
    var v4 = { id: "personal", value: "Personale" };
    this.typologies = [v1, v2, v3, v4];
  },
  data() {
    return {
      value: [],
      typologyData: null,
      applicantPersonId: null,
      askedForPersonId: null,
      trainingNeedId: null,
      requestData: null,
      typologies: null,
    };
  },
  methods: {
    setRequestText(event) {
      this.requestData =
        event.target.options[event.target.options.selectedIndex].text;
    },
  },
  props: {
    applicant_person_id: {
      type: Number,
      required: false,
      default: null,
    },
    asked_for_person_id: {
      type: Number,
      required: false,
      default: null,
    },
    training_need_id: {
      type: Number,
      required: false,
      default: null,
    },
    typology: {
      type: String,
      required: false,
      default: null,
    },
    request: {
      type: String,
      required: false,
      default: null,
    },
    courses: {
      type: Array,
      required: true,
    },
    catalogs_courses: {
      type: Array,
      required: true,
    },
    people: {
      type: Array,
      required: true,
    },
  },
};
</script>